import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {map, of} from 'rxjs';
import {UrlService} from '../url.service';

@Injectable()
export class NarrativeService {
    private BASE_URL: string;

    private instrumentTypeMap: Map<any, any> = null;

    constructor(private http: HttpClient,
                private urlService: UrlService) {
        this.BASE_URL = this.urlService.getBackendUrl() + 'data/v2/narrative';
    }

    getData(clientId, clientPlacementId, assessmentIds, hiddenIds, languageCode) {
        let params: HttpParams = new HttpParams();

        if (hiddenIds && hiddenIds.length !== 0) {
            let hiddenIdsString = '';
            for (const i of hiddenIds) {
                if (hiddenIdsString.length !== 0) {
                    hiddenIdsString += ',';
                }
                hiddenIdsString += hiddenIds[i];
            }
            params = params.set('hiddenIds', hiddenIdsString);
        }

        if (languageCode) {
            params = params.set('languageCode', languageCode);
        }

        const requestOptions = {
            params: params
        }

        return this.http.get(this.BASE_URL + '/' + clientId + '/' + clientPlacementId + '/' + assessmentIds, requestOptions);
    }

    getLanguageCodes() {
        return this.http.get(this.BASE_URL + '/languageCodes');
    }

    getStyle(value) {
        if (value === '4') {
            return 'strength';
        }
        if (value === '3') {
            return 'three';
        }
        if (value === '2') {
            return 'two';
        }
        if (value === '1') {
            return 'one';
        }
        if (value === '0') {
            return 'one';
        }
        if (value === '') {
            return 'one';
        }

        return '';
    }

    private setExplanation(instrumentType, items, languageCode) {
        items.forEach((item) => {

            const narrativeMap = this.instrumentTypeMap[instrumentType];
            if (narrativeMap) {

                let explanation = 'No narrative description available for this question.';


                // const category = _.findWhere(narrativeMap,
                //     {'questionIdentifier': item.questionIdentifier.trim()}
                // );
                const category = narrativeMap.find((element) => {
                    return element.questionIdentifier === item.questionIdentifier.trim();
                });

                // if (!_.isUndefined(category)) {
                if (category) {
                    const itemTextMap = category.Item;

                    if (itemTextMap !== null) {
                        const target = category[item.values[item.values.length - 1]];
                        if (target) {
                            if (target[languageCode] != null) {
                                explanation = target[languageCode];
                            } else if (target['EN'] != null) {
                                explanation = target['EN'];
                            }
                        }
                    }
                }

                item.explanation = explanation;
            }
        });
    };

    getTranslationDataMap() {
        if (this.instrumentTypeMap !== null) {
            return of(this.instrumentTypeMap);
        } else {
            const path = 'external/sbTextJsonV3.json';
            let params = new HttpParams();
            params = params.set('uriPath', path);

            const requestOptions = {
                params: params
            }

            return this.http.get(this.BASE_URL + '/translations', requestOptions).pipe(
                map((msg: any) => {
                    const map = new Map<any, any>();
                    for (let i = 0; i < msg.length; i++) {
                        const item = msg[i];
                        map[item.name] = item.domains;
                    }
                    this.instrumentTypeMap = map;
                    return map;
                }));
        }
    }

    translateAllQuestions(narrativeData, languageCode) {
        if (narrativeData) {
            const instrumentType = narrativeData.instrumentType;
            this.setExplanation(instrumentType, narrativeData.threes, languageCode);
            this.setExplanation(instrumentType, narrativeData.twos, languageCode);
            this.setExplanation(instrumentType, narrativeData.ones, languageCode);
            this.setExplanation(instrumentType, narrativeData.strengths, languageCode);
            this.setExplanation(instrumentType, narrativeData.strengthsToBuild, languageCode);
        }
    }
}
